import { Controller } from "@hotwired/stimulus"

// Muestra/oculta secciones según el valor de radio buttons.
//
// Uso en ERB:
//   <div data-controller="manage--radio-toggle">
//     <input type="radio" value="custom"
//            data-action="manage--radio-toggle#update"
//            data-manage--radio-toggle-target="radio">
//     <div data-manage--radio-toggle-target="section" data-show-when="custom" class="hidden">
//       ...campos visibles solo cuando radio == "custom"...
//     </div>
//   </div>

export default class extends Controller {
  static targets = ["radio", "section"]

  update() {
    const selected = this.radioTargets.find((r) => r.checked)?.value
    this.sectionTargets.forEach((section) => {
      const showWhen = section.dataset.showWhen
      section.classList.toggle("hidden", showWhen !== selected)
    })
  }
}
